import { render, staticRenderFns } from "./SelectAdType.vue?vue&type=template&id=be362a3e&scoped=true"
import script from "./SelectAdType.vue?vue&type=script&lang=js"
export * from "./SelectAdType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be362a3e",
  null
  
)

export default component.exports